import Form from "./Form";
import Input from './Input';

Form.Input = Input;

export default Form;
